import { EnvConfig } from '@bn/primitives';

/** bunny APIs that receive the PAT, matched against the start of the request URL. */
const PREFIX_MATCHED = [
  'apiUrl',
  'aiGatewayApiUrl',
  'changelogSubscriptionApiUrl',
  'apiMcUrl',
  'apiEdgeDbLiteUrl',
  'dnsLogsApiUrl',
  'cdnLoggingReportApiUrl',
  'cdnLogsApiUrl',
  'computeScriptingTestApiUrl',
  'shieldLogsUrl',
  'cdnOriginErrorLogsUrl',
  'surveysApiUrl',
  'streamStatisticsApiUrl',
] as const satisfies readonly (keyof EnvConfig)[];

/** Socket endpoints, matched anywhere in the URL because the request carries a scheme prefix. */
const SUBSTRING_MATCHED = ['mcWsUrl', 'mcLoggingUrl', 'scriptingWsUrl'] as const satisfies readonly (keyof EnvConfig)[];

export interface AuthenticatedUrls {
  prefixes: readonly string[];
  substrings: readonly string[];
}

/**
 * Resolves the allowlist once per interceptor instance rather than on every request.
 * Empty entries are dropped — `''` matches every URL and would leak the PAT to third parties.
 */
export const resolveAuthenticatedUrls = (envConfig: EnvConfig): AuthenticatedUrls => ({
  prefixes: PREFIX_MATCHED.map((key) => envConfig[key]).filter(Boolean),
  substrings: SUBSTRING_MATCHED.map((key) => envConfig[key]).filter(Boolean),
});

export const needsAccessKey = (url: string, { prefixes, substrings }: AuthenticatedUrls): boolean =>
  prefixes.some((prefix) => url.startsWith(prefix)) || substrings.some((fragment) => url.includes(fragment));
